import React, { useEffect } from "react";
import { Modal, TextInput, Textarea, Button, Grid } from "@mantine/core";
import { IconSend } from "@tabler/icons";
import { useSetState } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import { apiWithInterceptor } from "../../../../api";

const SendEmailModal = ({
  opened,
  setOpenEmail,
  sessionId,
  emailForApproved,
  emailForDenied,
  ticketId,
}) => {
  const [email, setEmail] = useSetState({
    title: "",
    message_en: "",
    message_ar: "",
  });

  useEffect(() => {
    if (localStorage.getItem("email template") === null) {
      setEmail({ title: "", message_ar: "", message_en: "" });
    } else {
      setEmail(JSON.parse(localStorage.getItem("email template")));
    }
  }, [opened]);

  return (
    <Modal
      opened={opened}
      onClose={() => {
        setOpenEmail(false);
      }}
      title={
        emailForApproved === true
          ? "Email to Approved"
          : emailForDenied === true
          ? "Email to Denied"
          : "Email To Specific"
      }
    >
      <form
        onSubmit={(event) => {
          event.preventDefault();
          emailForApproved === true
            ? apiWithInterceptor
                .post("/ticket/send-email-to-approved", {
                  title: email.title,
                  message_en: email.message_en,
                  message_ar: email.message_ar,
                  session_id: sessionId,
                })
                .then(() => {
                  setOpenEmail(false);
                  showNotification({
                    title: "Success",
                    message: "Email Successfully Sent",
                    color: "green",
                  });
                  localStorage.setItem(
                    "email template",
                    JSON.stringify({
                      title: email.title,
                      message_en: email.message_en,
                      message_ar: email.message_ar,
                    })
                  );
                })
                .catch((err) => {
                  console.log(err);
                  showNotification({
                    title: "Failed",
                    message: "Something went wrong :(",
                    color: "red",
                  });
                })
            : emailForDenied === true
            ? apiWithInterceptor
                .post("/ticket/send-email-to-denied", {
                  title: email.title,
                  message: email.message,
                  session_id: sessionId,
                })
                .then(() => {
                  setOpenEmail(false);
                  showNotification({
                    title: "Success",
                    message: "Email Successfully Sent",
                    color: "green",
                  });
                })
                .catch((err) => {
                  showNotification({
                    title: "Failed",
                    message: "Something went wrong :(",
                    color: "red",
                  });
                  console.log(err);
                })
            : apiWithInterceptor
                .post("/ticket/send-email-to-ticket", {
                  title: email.title,
                  message: email.message,
                  ticket_id: ticketId,
                })
                .then(() => {
                  setOpenEmail(false);
                  showNotification({
                    title: "Success",
                    message: "Email Successfully Sent",
                    color: "red",
                  });
                })
                .catch((err) => {
                  console.log(err);
                  showNotification({
                    title: "Failed",
                    message: "Something went wrong :(",
                    color: "green",
                  });
                });
        }}
      >
        <Grid>
          <Grid.Col>
            <TextInput
              variant="filled"
              label="Email Header"
              placeholder="Enter the title of the email..."
              value={email.title}
              onChange={(e) => setEmail({ title: e.target.value })}
            />
          </Grid.Col>
          <Grid.Col>
            <Textarea
              variant="filled"
              label="Email Body Arabic"
              placeholder="Enter the message of the email in arabic..."
              value={email.message_ar}
              onChange={(e) => setEmail({ message_ar: e.target.value })}
            />
          </Grid.Col>
          <Grid.Col>
            <Textarea
              variant="filled"
              label="Email Body"
              placeholder="Enter the message of the email..."
              value={email.message_en}
              onChange={(e) => setEmail({ message_en: e.target.value })}
            />
          </Grid.Col>

          <Grid.Col>
            <Button
              type="submit"
              variant="filled"
              label="Email Body"
              placeholder="Enter the message of the email..."
              rightIcon={<IconSend size={15} />}
            >
              Send
            </Button>
          </Grid.Col>
        </Grid>
      </form>
    </Modal>
  );
};

export default SendEmailModal;
